<template>
  <section class="features">
    <div class="sectionImg">
      <div class="cnt sectionImgIn">
        <div class="theImg" v-if="section.items && section.items.length > 0 && section.items[0][lang]">
          <img :src="section.items[0][lang].imageMd" :style="{width: section.width,
            height: section.height}">
        </div>
        <div class="theImg noImg" v-else
          :style="{width: (section.width && section.width !== 'auto') ? section.width : '240px',
            height: (section.height && section.height !== 'auto') ? section.height : '240px'}"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'sectionImg',
  props: ['section'],
  components: {},
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {},
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.theImg.noImg{
  width: 240px; height: 240px;
  margin: 0 auto;
  background-color: #ccc;
  background-image: url(../../assets/image-black.png);
  background-size: 18% auto;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 5px;
  opacity: .36;
}
</style>
